import {
    Box,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text
} from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC, useRef } from 'react';
import { User } from 'src/models';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    currentUser?: User;
    users?: User[];
    setCurrentUserId?: (users: User[], userId?: string | undefined) => void;
};

const SelectUserModal: FC<Props> = (props) => {
    const { isOpen, onClose, currentUser, users, setCurrentUserId } = props;
    const { t } = useTranslation('home');
    const initialFocusRef = useRef<HTMLInputElement>(null);

    const handleUserClick = (users: User[], userId: string) => {
        setCurrentUserId && setCurrentUserId(users, userId);
        onClose();
    };

    return (
        <>
            <Modal initialFocusRef={initialFocusRef} isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>{t('select-a-user')}</ModalHeader>
                    <ModalCloseButton size="lg" />
                    <ModalBody>
                        <Box display="flex" flexDirection="column" gap={4}>
                            {users
                                ?.filter((user) => !user.isDeleted)
                                .map((user) => (
                                    <Box
                                        key={user.id}
                                        background={
                                            currentUser?.id === user.id ? 'lime.50' : 'white'
                                        }
                                        border={currentUser?.id === user.id ? '1px' : undefined}
                                        borderColor={
                                            currentUser?.id === user.id ? 'lime.300' : undefined
                                        }
                                        borderRadius="md"
                                        boxShadow={
                                            currentUser?.id === user.id
                                                ? '0 0 0 1px #53E88B'
                                                : '12px 26px 50px rgba(90, 108, 234, 0.07)'
                                        }
                                        cursor="pointer"
                                        padding={4}
                                        onClick={() => handleUserClick(users, user?.id)}>
                                        <Text>
                                            {user.firstName} {user.lastName}
                                        </Text>
                                    </Box>
                                ))}
                        </Box>
                    </ModalBody>
                    <ModalFooter />
                </ModalContent>
            </Modal>
        </>
    );
};

export default SelectUserModal;
